import React from "react";
import PanelLayout from "layouts/PanelLayout";
import { TbSmartHome } from "react-icons/tb";
import { useNavigate, useLocation } from "react-router-dom";
import "styles/student.css";

const StudentResultTablePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const test = location.state?.test;

  const QUESTIONS = [
    {
      id: 8,
      question:
        "Lorem ipsum dolor sit amet consectetur. Tincidunt sit leo elementum dictum pellentesque.",
      attempt: 1,
      variants: [
        { id: 1, text: "Variant 1", correct: false, selected: true },
        { id: 2, text: "Variant 2", correct: false },
        { id: 3, text: "Variant 3", correct: true },
        { id: 4, text: "Variant 4", correct: false },
      ],
    },
    {
      id: 14,
      question:
        "Lorem ipsum dolor sit amet consectetur. Tincidunt sit leo elementum dictum pellentesque.",
      attempt: 1,
      variants: [
        { id: 1, text: "Variant 1", correct: false, selected: true },
        { id: 2, text: "Variant 2", correct: false },
        { id: 3, text: "Variant 3", correct: true },
        { id: 4, text: "Variant 4", correct: false },
      ],
    },
    {
      id: 17,
      question:
        "Lorem ipsum dolor sit amet consectetur. Tincidunt sit leo elementum dictum pellentesque.",
      attempt: 2,
      variants: [
        { id: 1, text: "Variant 1", correct: false, selected: false },
        { id: 2, text: "Variant 2", correct: false },
        { id: 3, text: "Variant 3", correct: true, selected: true },
        { id: 4, text: "Variant 4", correct: false },
      ],
    },
  ];

  return (
    <PanelLayout>
      <div className="student-result-page">
        <div className="tests-header">
          <div className="breadcrumb">
            <span
              className="breadcrumb-icon"
              onClick={() => navigate("/student")}
            >
              <TbSmartHome />
            </span>
            <span className="divider">/</span>
            <span className="breadcrumb-link" onClick={() => navigate(-1)}>
              Natijalar
            </span>
            <span className="divider">/</span>
            <span className="current">Batafsil</span>
          </div>
        </div>

        {/* Questions list */}
        {QUESTIONS.map((q) => (
          <div key={q.id} className="result-card">
            <div className="result-header">
              <h3>Savol – {q.id}</h3>
              <span className="attempt">{q.attempt}-urinish</span>
            </div>

            <p className="question-text">{q.question}</p>

            <div className="variants">
              {q.variants.map((v) => (
                <div key={v.id} className="variant-item">
                  <span
                    className={`radio-circle 
                      ${v.correct ? "correct" : ""} 
                      ${v.selected && !v.correct ? "wrong" : ""}
                    `}
                  ></span>

                  <p
                    className={`
                      ${v.correct ? "text-correct" : ""} 
                      ${v.selected && !v.correct ? "text-wrong" : ""}
                    `}
                  >
                    {v.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </PanelLayout>
  );
};

export default StudentResultTablePage;
